import {styled, Box} from 'external/material'
import DashboardActivity from './DashboardActivity'
import DashboardCarruselContainer from './DashboardCarrusel/DashboardCarruselContainer'
import useProfile from 'hooks/profile'
import { useMemo } from 'external/react'

import DashboardMessages from './DashboardMessages'

const StyledDashBoardContent = styled(Box)(dashboardContentStyles)

export default function DashboardContent() {
  const { institution, domainName } = useProfile()
  const isDreyfous = useMemo(() => /^dreyfous.*/.test(domainName), [domainName])
  const isDgenius = useMemo(() => institution.project == 'dgenius', [institution.project])
  return (
    <StyledDashBoardContent className="dashboardContentWrapper">
      <Box id="dashboardContentContainer" className="dashboardContentContainer">
        <DashboardMessages />
        <DashboardActivity />
        <DashboardCarruselContainer />
      </Box>
    </StyledDashBoardContent>
  )
}

function dashboardContentStyles() {
  return {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 0px 0px 30px',
    flexGrow: 1,
    overflowY: 'hidden',
    "& .dashboardContentContainer": {
      display: 'flex',
      paddingRight: 20,
      flexDirection: 'column',
      flexGrow: 1,
      overflow: 'auto'
      // overflowY: 'hidden'
    },
  }
}
